module.exports = __webpack_public_path__ + "img/5.b1e3fb6.png";